// extracted by mini-css-extract-plugin
export default {"carousel-wrapper":"Carousel__carousel-wrapper--c_yKt","carousel-container":"Carousel__carousel-container--ohkEi","carousel-track":"Carousel__carousel-track--x26Hh"};